import { Component, Inject, LOCALE_ID, NgZone, PLATFORM_ID } from '@angular/core';
import { filter, map, mergeMap, switchMap, take, takeUntil } from 'rxjs/operators';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { LoggedStatus } from 'src/app/services/auth/login/login.models';
import { missionsTrx } from 'src/app/router-translation.labels';
import { Router } from '@angular/router';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { isPlatformServer } from '@angular/common';
import { MissionInfoBoxComponent } from '../mission-info-box/mission-info-box.component';
import { MissionService } from 'src/app/services/missions/mission.service';
import { Mission } from 'src/app/services/missions/missions.models';
import { MissionDetailsService } from 'src/app/services/missions/mission-details.service';
import { SwiperOptions } from 'swiper';
import { LicenceService } from 'src/app/services/utils/licence.service';

import { UserCampaignService } from 'src/app/services/campaigns/campaign.service';

@Component({
  selector: 'app-mission-category',
  templateUrl: './mission-category.component.html',
  styleUrls: ['./mission-category.component.scss']
})
export class MissionCategoryComponent extends MissionInfoBoxComponent {

  missions: Mission[] = [];
  missionsAll: Mission[] = [];
  public missionsTrx = missionsTrx;
  constructor(
    @Inject(LOCALE_ID) public locale: string,
    @Inject(PLATFORM_ID) private platformId,
    public router: Router,
    public missionDetailsService: MissionDetailsService,
    public missionService: MissionService,
    public detectDeviceService: DetectDeviceService,
    protected _ngZone: NgZone,
    public loginStatus: LoginStatusService,
    public licenceService: LicenceService,
    public userCampaignService:UserCampaignService
  ) {
    super(locale, router, missionDetailsService, missionService, detectDeviceService, missionDetailsService, loginStatus, _ngZone, licenceService);
  }

  isServer: boolean;
  isLoading = false;
  status: any = 'all';
  isLogged: boolean;

  public config: SwiperOptions = {
    direction: 'horizontal',
    slideToClickedSlide: false,
    mousewheel: true,
    scrollbar: false,
    navigation: false,
    keyboard: true,
    freeMode: true,
    slidesPerView: 3.7,
    centerInsufficientSlides: false,
    centeredSlides: false,
    loop: false,
    simulateTouch: true,
    roundLengths: true,
    spaceBetween: 16
  };

  ngOnInit(): void {
    this.isServer = isPlatformServer(this.platformId);
    this.isLoading = true;
    this.missionService.getInAppTournamentMetaData().pipe(take(1)).subscribe((resp) => {
      this.setSEOTags(resp.seo?.metaTitle, resp.seo?.metaDescription, resp.seo?.relCanonical)
    })
    this.getTournament();

  }

  getTournament() {
    this.loginStatus.getLoginStatus().pipe(
      filter(status => status.isLogged !== LoggedStatus.voidState),
      switchMap((status) => {
        return this.missionService.updateMissionsStore().pipe(
          map(tournaments => ({ tournaments, isLogged: status.isLogged === LoggedStatus.logged }))
        )
      }),
      takeUntil(this.unsubscribe)
    ).subscribe(resp => {
      this.isLoading = false;
      // this.numberTournaments = resp.length;
      if(!resp.isLogged){
        resp.tournaments = resp.tournaments.filter(x=>!x.isPrizeEngineEligiblePlayers)
      }
      this.missions = resp.tournaments;
      this.missionsAll = resp.tournaments;
      this.checkCampaign(this.missions);
      console.log(this.missions)
    });
  }

  filterTour(status: any) {
    this.status = status;
    let allTour = this.missionsAll;
    if (status != 'all')
      this.missions = allTour.filter(x => x.missionType == this.status)
    else
      this.missions = allTour;

    console.log('filter', this.missions)
  }

  checkCampaign(mission:any) {
    var missionRef = [];
    mission.filter(x=> {
      if(x.id)
        missionRef.push(x.id)
      })
    this.userCampaignService.isUserEligibleCampaignMissions(missionRef).subscribe(res=> {
      console.log('isUserEligibleCampaignMissions', res);
    })
  }

}
